module.exports = __webpack_public_path__ + "static/web_development-d8ca8f3c48afbd58df91f387b2fc9774.jpg";